import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';

export interface ErrorListState {
    errors: any;
}

const initialState: ErrorListState = {
    errors: {},
};

export const errorListSlice = createSlice({
    name: 'errorList',
    initialState,
    reducers: {
        pushError: (state, action) => {
            state["errors"][action.payload.id] = action.payload.value;
        },
        setValue: (state, action) => {
            state["errors"][action.payload.id]["value"] = action.payload.value;
        },
        setErrorText: (state, action) => {
            state["errors"][action.payload.id]["errorText"] = action.payload.value;
        },
        replaceAllErrors: (state, action: PayloadAction<Record<string, any>>) => {
            state.errors = action.payload;
        },
    },
});

export const { pushError, setValue, setErrorText, replaceAllErrors } = errorListSlice.actions;

export const selectErrors = (state: RootState) => state.errorList.errors;
export const selectErrorById = (id: number | undefined) => (state: RootState) =>
    id !== undefined ? state.errorList.errors[id] : undefined;

export default errorListSlice.reducer;